export enum AppBundle {
  Journeys = 'journeys',
  Pipelines = 'pipelines',
  DesignStudio = 'design-studio',
}

export function isAppBundle(app: string) {
  return (Object.values(AppBundle) as string[]).includes(app);
}

export const AppBundleRoutes = {
  [AppBundle.Journeys]: '/journeys',
  [AppBundle.Pipelines]: '/pipelines',
  [AppBundle.DesignStudio]: '/design-studio',
};

export const AppBundleNames = {
  [AppBundle.Journeys]: 'Journeys',
  [AppBundle.Pipelines]: 'Data Pipelines',
  [AppBundle.DesignStudio]: 'Design Studio',
};

declare global {
  interface Window {
    __hydra_preload_app_bundles__?: {
      [key in AppBundle]: Promise<unknown> | undefined;
    };
  }
}

export const registerPreloadPromise = (bundle: AppBundle, callback: () => Promise<unknown>) => {
  if (window.__hydra_preload_app_bundles__ == null) {
    Object.assign(window, {
      __hydra_preload_app_bundles__: {
        [AppBundle.Journeys]: undefined,
        [AppBundle.Pipelines]: undefined,
        [AppBundle.DesignStudio]: undefined,
      },
    });
  }

  if (window.__hydra_preload_app_bundles__?.[bundle] != null) {
    return;
  }

  (window.__hydra_preload_app_bundles__ ?? {})[bundle] = callback();
};

export const getEntrypoint = async (bundle: AppBundle) => {
  const preloadPromise = window.__hydra_preload_app_bundles__?.[bundle];
  if (preloadPromise == null) {
    return await window.importShim(bundle);
  }

  return await preloadPromise;
};
